var cibFlipboard = ["32 32", "<path d='M0 0v32h32v-32zM25.599 12.803h-6.401v6.395h-6.395v6.401h-6.401v-19.197h19.197z'/>"];

export { cibFlipboard };
//# sourceMappingURL=cib-flipboard.js.map
